import { NeuInput } from "../../components/neu/Neu";
import { formatCurrency } from "./reportFormat";
import { S } from "./settlementLabels";

const Field = ({ label, hint, value, onChange, testid }) => (
  <label className="grid gap-1 text-xs font-bold">
    <span className="text-muted-foreground">{label}</span>
    <NeuInput type="number" value={value} data-testid={testid}
              onChange={(e) => onChange(Number(e.target.value || 0))} />
    <span className="text-[10px] font-normal text-muted-foreground">{hint}</span>
  </label>
);

// الحقول المالية القابلة للتعديل مع شرح معادلة كل بند + الصافي النهائي المحسوب مباشرةً.
export const SettlementFields = ({ p, lang, onChange }) => {
  const L = S[lang === "en" ? "en" : "ar"];
  const n = (v) => Number(v || 0);
  const net = n(p.accrued_salary) + n(p.gratuity) - n(p.deductions);
  return (
    <div className="grid gap-4" data-testid="settlement-fields">
      <Field label={L.rows.accrued} hint={L.hints.accrued} value={p.accrued_salary} testid="settle-accrued"
             onChange={(v) => onChange("accrued_salary", v)} />
      <Field label={L.rows.gratuity} hint={L.hints.gratuity} value={p.gratuity} testid="settle-gratuity"
             onChange={(v) => onChange("gratuity", v)} />
      <Field label={L.rows.deductions} hint={L.hints.deductions} value={p.deductions} testid="settle-deductions"
             onChange={(v) => onChange("deductions", v)} />
      <div className="flex items-center justify-between rounded-2xl bg-primary/10 px-4 py-3" data-testid="settle-net">
        <span className="text-sm font-black text-primary">{L.rows.net}</span>
        <span className="text-lg font-black text-primary">{formatCurrency(net, p.currency)}</span>
      </div>
    </div>
  );
};
